/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look at the overall pattern of points. An upward trend means the two variables increase together; a downward trend means one falls as the other rises; a random spread means little or no relationship.`)
};

const es_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observa el patrón general de los puntos. Una tendencia ascendente significa que las dos variables aumentan juntas; una tendencia descendente significa que una disminuye mientras la otra aumenta; una dispersión aleatoria significa poca o ninguna relación.`)
};

const de_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrachten Sie das Gesamtmuster der Punkte. Ein aufsteigender Trend bedeutet, dass die beiden Variablen gemeinsam zunehmen; ein absteigender Trend bedeutet, dass eine sinkt, während die andere steigt; eine zufällige Streuung bedeutet wenig oder keinen Zusammenhang.`)
};

const nl_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijk naar het algemene patroon van de punten. Een stijgende trend betekent dat de twee variabelen samen toenemen; een dalende trend betekent dat de ene daalt terwijl de andere stijgt; een willekeurige spreiding betekent weinig of geen verband.`)
};

const fr_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observez le motif général des points. Une tendance ascendante signifie que les deux variables augmentent ensemble ; une tendance descendante signifie que l'une diminue quand l'autre augmente ; une répartition aléatoire signifie peu ou pas de relation.`)
};

const it_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osserva lo schema generale dei punti. Una tendenza crescente significa che le due variabili aumentano insieme; una tendenza decrescente significa che una diminuisce mentre l'altra aumenta; una distribuzione casuale significa poca o nessuna relazione.`)
};

const pt_br2_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observe o padrão geral dos pontos. Uma tendência ascendente significa que as duas variáveis aumentam juntas; uma tendência descendente significa que uma diminui enquanto a outra aumenta; uma dispersão aleatória significa pouca ou nenhuma relação.`)
};

const pt_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observe o padrão geral dos pontos. Uma tendência ascendente significa que as duas variáveis aumentam em conjunto; uma tendência descendente significa que uma diminui enquanto a outra aumenta; uma distribuição aleatória significa pouca ou nenhuma relação.`)
};

const ja_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点全体のパターンに注目してください。上昇傾向は2つの変数が共に増加することを、下降傾向は一方が増えると他方が減ることを、ランダムな散らばりはほとんど関係がないことを意味します。`)
};

const zh_scatter_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观察点的总体分布模式。上升趋势表示两个变量同步增加；下降趋势表示一个变量增加时另一个减少；随机分布则表示两者几乎没有关系。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_faq_a2", locale)
	if (locale === "en") return en_scatter_faq_a2(inputs)
	if (locale === "es") return es_scatter_faq_a2(inputs)
	if (locale === "de") return de_scatter_faq_a2(inputs)
	if (locale === "nl") return nl_scatter_faq_a2(inputs)
	if (locale === "fr") return fr_scatter_faq_a2(inputs)
	if (locale === "it") return it_scatter_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_faq_a2(inputs)
	if (locale === "pt") return pt_scatter_faq_a2(inputs)
	if (locale === "ja") return ja_scatter_faq_a2(inputs)
	return zh_scatter_faq_a2(inputs)
};